export type NonEmptyArray<T> = [T, ...T[]]

export const isNonEmptyArray = <T>(arr: T[]): arr is NonEmptyArray<T> =>
  arr.length > 0

export const isNotNullOrUndefined = <T>(
  value: T | null | undefined
): value is T => value !== null && value !== undefined

export const hasDuplicates = <T>(arr: T[]): boolean =>
  new Set(arr).size < arr.length
